import css from "styled-jsx/css";

export default css`
  .switch-fake {
    display: flex;
    flex-direction: column;
    &--charac {
      border-radius: 15px;
      width: 40px;
      height: 24px;
    }
  }

  @media (min-width: 768px) {
    .switch-fake {
      &--charac {
        border-radius: 15px;
        height: 24px;
        width: 40px;
      }
    }
  }
`;
